import Article1 from "../../assets/webp-ideas/hydr-blog.webp";
import Article2 from "../../assets/webp-ideas/1414.webp";
import Article3 from "../../assets/webp-ideas/380.webp";

function Article() {
  return (
    <section className="ArticleSection">
      <div className="container-fluid">
        <h1>News & Articles</h1>
        <h2>Blogs</h2>

        <div className="row mt-5">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <a href="/BlogDetails" className="card article-card article-card-link">
                <div className="articleImge">
                  <img
                    src={Article1}
                    className="card-img-top img-fluid"
                    alt="Ideas-img"
                  />
                </div>
                <div className="card-body article-card-body">
                  <div className="artivleTitle">
                      <h3>Hydropower Generation</h3>
                  </div>
                  <div className="articlePar">
                    <p>
                      Hydropower, or hydroelectric power, is one of the oldest
                      and largest sources of renewable energy, which uses the
                      natural flow of moving water to generate electricity.
                    </p>
                  </div>
                </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <a href="/TransmitionStatus" className="card article-card article-card-link">
                <div className="articleImge">
                  <img
                    src={Article2}
                    className="card-img-top img-fluid"
                    alt="Ideas-img"
                  />
                </div>
                <div className="card-body article-card-body">
                  <div className="artivleTitle">
                      <h3>Transmission & Distribution Status</h3>
                  </div>
                  <div className="articlePar">
                    <p>
                      Transmission plays a pivotal role in the supply of power
                      to consumers through the vital link between the generating
                      stations and the distribution system. Over the years the
                      transmission system has expanded for the evacuation of
                      power from generating stations to load centres through
                      Intra State and Inter State Transmission System.
                    </p>
                  </div>
                </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <a href="/Transmition" className="card article-card article-card-link">
                <div className="articleImge">
                  <img
                    src={Article3}
                    className="card-img-top img-fluid"
                    alt="Ideas-img"
                  />
                </div>
                <div className="card-body article-card-body">
                  <div className="artivleTitle">
                      <h3>Transmission & Distribution</h3>
                  </div>
                  <div className="articlePar">
                    <p>
                      Transmission and distribution are crucial elements of the
                      electricity supply chain, responsible for delivering power
                      from generating stations to consumers. There are
                      significant global differences in how countries handle
                      transmission and distribution based on their
                      infrastructure, regulatory frameworks, and geographical
                      considerations.
                    </p>
                  </div>
                </div>
            </a>
          </div>
        </div>
        <div className="ArticleButton text-center">
          <a href="./blogs" className="button">
            View More
          </a>
        </div>
      </div>
    </section>
  );
}

export default Article;